// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import {
  OpcUaNodeLiftIndexEntry,
  OpcUaNodeLiftIndexEntryT,
  verifyOpcUaNodeLiftIndexEntry,
} from "./opc-ua-node-lift-index-entry";

/**
 * A bank's full set of OPC UA node->lift index bindings.
 */
export class OpcUaNodeLiftIndexBindings implements flatbuffers.IUnpackableObject<OpcUaNodeLiftIndexBindingsT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): OpcUaNodeLiftIndexBindings {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsOpcUaNodeLiftIndexBindings(
    bb: flatbuffers.ByteBuffer,
    obj?: OpcUaNodeLiftIndexBindings,
  ): OpcUaNodeLiftIndexBindings {
    return (obj || new OpcUaNodeLiftIndexBindings()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsOpcUaNodeLiftIndexBindings(
    bb: flatbuffers.ByteBuffer,
    obj?: OpcUaNodeLiftIndexBindings,
  ): OpcUaNodeLiftIndexBindings {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new OpcUaNodeLiftIndexBindings()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  entries(index: number, obj?: OpcUaNodeLiftIndexEntry): OpcUaNodeLiftIndexEntry | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new OpcUaNodeLiftIndexEntry()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  entriesLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  static startOpcUaNodeLiftIndexBindings(builder: flatbuffers.Builder) {
    builder.startObject(1);
  }

  static addEntries(builder: flatbuffers.Builder, entriesOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, entriesOffset, 0);
  }

  static createEntriesVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startEntriesVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static endOpcUaNodeLiftIndexBindings(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static finishOpcUaNodeLiftIndexBindingsBuffer(
    builder: flatbuffers.Builder,
    offset: flatbuffers.Offset,
  ) {
    builder.finish(offset);
  }

  static finishSizePrefixedOpcUaNodeLiftIndexBindingsBuffer(
    builder: flatbuffers.Builder,
    offset: flatbuffers.Offset,
  ) {
    builder.finish(offset, undefined, true);
  }

  static createOpcUaNodeLiftIndexBindings(
    builder: flatbuffers.Builder,
    entriesOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    OpcUaNodeLiftIndexBindings.startOpcUaNodeLiftIndexBindings(builder);
    OpcUaNodeLiftIndexBindings.addEntries(builder, entriesOffset);
    return OpcUaNodeLiftIndexBindings.endOpcUaNodeLiftIndexBindings(builder);
  }

  unpack(): OpcUaNodeLiftIndexBindingsT {
    return new OpcUaNodeLiftIndexBindingsT(
      this.bb!.createObjList<OpcUaNodeLiftIndexEntry, OpcUaNodeLiftIndexEntryT>(
        this.entries.bind(this),
        this.entriesLength(),
      ),
    );
  }

  unpackTo(_o: OpcUaNodeLiftIndexBindingsT): void {
    _o.entries = this.bb!.createObjList<OpcUaNodeLiftIndexEntry, OpcUaNodeLiftIndexEntryT>(
      this.entries.bind(this),
      this.entriesLength(),
    );
  }

  unpackFields(...fields: string[]): OpcUaNodeLiftIndexBindingsT {
    const t = new OpcUaNodeLiftIndexBindingsT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("entries")) {
      t.entries = this.bb!.createObjList<OpcUaNodeLiftIndexEntry, OpcUaNodeLiftIndexEntryT>(
        this.entries.bind(this),
        this.entriesLength(),
      );
    }
    return t;
  }
}

export class OpcUaNodeLiftIndexBindingsT implements flatbuffers.IGeneratedObject {
  constructor(public entries: OpcUaNodeLiftIndexEntryT[] = []) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    const entries = OpcUaNodeLiftIndexBindings.createEntriesVector(
      builder,
      builder.createObjectOffsetList(this.entries),
    );

    return OpcUaNodeLiftIndexBindings.createOpcUaNodeLiftIndexBindings(builder, entries);
  }

  clone(): OpcUaNodeLiftIndexBindingsT {
    const obj = new OpcUaNodeLiftIndexBindingsT();
    obj.entries = this.entries.map((e) => e.clone());
    return obj;
  }

  equals(other: OpcUaNodeLiftIndexBindingsT): boolean {
    if (this.entries.length !== other.entries.length) return false;
    for (let i = 0; i < this.entries.length; i++) {
      const a = this.entries[i];
      const b = other.entries[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    return true;
  }
}

export function verifyOpcUaNodeLiftIndexBindings(
  verifier: flatbuffers.Verifier,
  tablePos: number,
): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyOpcUaNodeLiftIndexEntry);
      }
    }
  } finally {
    verifier.popDepth();
  }
}

export function verifyRootAsOpcUaNodeLiftIndexBindings(
  buf: DataView,
  opts?: flatbuffers.VerifierOptions,
): void {
  const verifier = new flatbuffers.Verifier(buf, opts);
  const tablePos = verifier.readUint32(0);
  verifyOpcUaNodeLiftIndexBindings(verifier, tablePos);
}
